<template>
    <div>

        <p class="m-2 font-medium">Filter by: </p>
        <div class="m-2 flex flex-row flex-wrap gap-2 items-center">
            <button
            v-for="btn in buttons"
            :key="btn.key"
            :class="['shadow text-center px-2 rounded-full font-medium transition-opacity cursor-pointer', btn.activeClass, active[btn.key] ? 'opacity-100' : 'opacity-30']"
      style="height: 30px; min-width: 30px;"
      @click="toggle(btn.key)"
    >
    <span v-html="btn.label"></span>
</button>
</div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "CVEFilter",
  data() {
    return {
      active: {
        compiler: false,
        checker: false,
        approver: false,
        cve: false,
        none: false,
      },
    };
  },
  computed: {
    buttons() {
      return [
        { key: "compiler", label: "Co",       activeClass: "bg-gradient-to-br from-gray-50 to-gray-200 text-text" },
        { key: "checker",  label: "Ck",       activeClass: "bg-gradient-to-br from-blue-200 to-blue-400 text-white" },
        { key: "approver", label: "Ap",       activeClass: "bg-gradient-to-br from-orange-300 to-orange-400 text-white" },
        { key: "cve",      label: "CVE",      activeClass: "bg-gradient-to-br from-green-300 to-green-400 text-xxs font-bold text-white" },
        { key: "none",     label: "&#10006;", activeClass: "bg-red-100 text-red" },
      ];
    },
    isAnyActive() {
      return Object.values(this.active).some(Boolean);
    },
  },
  methods: {
    toggle(key) {
      this.active[key] = !this.active[key];
      this.params.onModelChange(this.isAnyActive ? { ...this.active } : null);
    },

    refresh(newParams) {
      if (newParams.model === null || newParams.model === undefined) {
        Object.keys(this.active).forEach((k) => (this.active[k] = false));
      } else {
        this.active = { ...this.active, ...newParams.model };
      }
    },
  },
});
</script>
